/**
 * Referenzzählender Body-Scroll-Lock für übereinanderliegende Modale/Sheets.
 * Verhindert, dass ein zweiter Lock den „vorherigen“ Zustand als bereits `hidden`
 * speichert und nach dem Schliessen die Seite eingefroren lässt.
 */
let depth = 0;
let savedOverflow = "";
let savedPaddingRight = "";

/**
 * @returns {() => void} release — idempotent
 */
export function acquireBodyScrollLock() {
  if (typeof document === "undefined") return () => {};
  if (depth === 0) {
    savedOverflow = document.body.style.overflow;
    savedPaddingRight = document.body.style.paddingRight;
    const scrollbarGap = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarGap > 0) {
      document.body.style.paddingRight = `${scrollbarGap}px`;
    }
    document.body.style.overflow = "hidden";
  }
  depth += 1;

  let done = false;
  return function releaseBodyScrollLock() {
    if (done || typeof document === "undefined") return;
    done = true;
    depth = Math.max(0, depth - 1);
    if (depth === 0) {
      document.body.style.overflow = savedOverflow;
      document.body.style.paddingRight = savedPaddingRight;
    }
  };
}
